import React, { createRef } from "react";
import { Table, Button, Input, Icon, Tooltip } from "antd";
import { Utilitaries, User_Preferences } from "../../../../business/index";

export function ProcessTable({ handleInitProcess, handleTableChange, data, loading, startingProcessIndex, filter }) {
    const handleSearch = (_, confirm) => {
        confirm();
    };

    const handleReset = (clearFilters) => {
        clearFilters();
    };

    const getColumnSearchProps = () => {
        const searchInput = createRef();
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            ref={searchInput}
                            placeholder={`Pesquisar`}
                            value={selectedKeys[0]}
                            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => handleSearch(selectedKeys, confirm)}
                            style={{ width: 198, marginBottom: 8, display: "block" }}
                        />
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm)}
                            icon="search"
                            size="small"
                            style={{ width: 100, marginRight: 8 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" icon="cl" style={{ width: 90 }}>
                            limpar
                        </Button>
                    </div>
                );
            },
            filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
            onFilterDropdownVisibleChange: (visibleDropdown) => {
                if (visibleDropdown) {
                    setTimeout(() => searchInput?.current?.focus(), 100);
                }
            },
        };
    };

    const getDefaultFilter = (key) => {
        const defualtFilter = User_Preferences.getTemporaryInitProocessFilters();
        const filteredValue = defualtFilter[key];

        return {
            filteredValue: filteredValue ? [filteredValue] : [],
        };
    };

    function getColumnSortProps(key) {
        if (filter.sorter && filter.sorter.columnKey === key) {
            const sortOrder = filter.sorter.order;
            return {
                sorter: true,
                sortOrder: sortOrder ? sortOrder : false,
            };
        }

        return {
            sorter: true,
            sortOrder: false,
        };
    }

    const columns = [
        {
            title: "Código",
            dataIndex: "codigo_externo",
            key: "codigo_externo",
            ...getDefaultFilter("filtro_codigo_externo"),
            ...getColumnSearchProps("codigo_externo"),
            ...getColumnSortProps("codigo_externo"),
        },
        {
            title: "Nome Processo",
            dataIndex: "nome_externo",
            key: "nome_externo",
            ...getDefaultFilter("filtro_nome_externo"),
            ...getColumnSearchProps("nome_externo"),
            ...getColumnSortProps("nome_externo"),
        },
        {
            title: "Âmbito",
            dataIndex: "ambito",
            key: "ambito",
            ...getColumnSearchProps("ambito"),
            ...getDefaultFilter("filtro_ambito"),
            ...getColumnSortProps("ambito"),
            render: (text) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            textOverflow: "ellipsis",
                            width: " 200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                        }}
                    >
                        {text}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Ações",
            key: "action",
            render: (_, record, index) => {
                const isDisabled = startingProcessIndex !== null && startingProcessIndex !== index;

                return (
                    <Button
                        type="link"
                        onClick={() => {
                            handleInitProcess(record);
                        }}
                        loading={startingProcessIndex === index}
                        disabled={isDisabled}
                    >
                        {Utilitaries.isEmpty(record.forma_iniciar) ? "Iniciar" : "Opções"}
                    </Button>
                );
            },
        },
    ];

    return (
        <Table
            size="middle"
            rowKey={(data) => data.index + "-table"}
            onRow={(record) => ({
                onDoubleClick: () => {
                    const isDisabled = startingProcessIndex !== null && startingProcessIndex !== record.index;
                    if (isDisabled) return;
                    handleInitProcess(record);
                },
            })}
            bodyStyle={{
                cursor: "pointer",
            }}
            columns={columns}
            dataSource={data}
            pagination={false}
            loading={loading}
            onChange={handleTableChange}
        />
    );
}
